import { html } from "../../render";
import { attr, cn, safeRandomId, spreadAttrs } from "../../utils";
import { LpIcon } from "../icon";
const filterBarManagedAttrs = [
    "data-lp-component",
    "class",
];
const filterCellManagedAttrs = [
    "data-lp-component",
    "class",
];
const searchInputManagedAttrs = [
    "data-lp-component",
    "class",
    "type",
    "placeholder",
    "aria-label",
];
export function LpFilterBar({ controls, actions, inline = true, dropdownLabel = "Filters", className, attributes, }) {
    const dropdownId = `lp-filter-bar-${safeRandomId()}`;
    return html `
        <div
            data-lp-component="FilterBar"
            class="${cn("lp-filter-bar", "control-bar", inline && "control-bar--inline-filters", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: filterBarManagedAttrs })}
        >
            <div class="control-bar__layout">
                <div class="control-bar__controls">
                    <div class="lp-filter-bar__filters">
                        <input id="${dropdownId}" class="lp-filter-bar__toggle" type="checkbox" />
                        <label class="lp-filter-bar__summary" for="${dropdownId}">
                            ${LpIcon({ name: "sliders-horizontal", size: 16, className: "lp-filter-bar__summary-icon" })}
                            <span class="lp-filter-bar__summary-label">${dropdownLabel}</span>
                            ${LpIcon({ name: "caret-down", size: 16, className: "lp-filter-bar__summary-caret" })}
                        </label>
                        <div class="lp-filter-bar__dropdown insights-filters-secondary insights-global-filters">
                            <header class="lp-filter-bar__dropdown-header insights-global-filters__header">
                                <h2 class="lp-filter-bar__dropdown-title insights-global-filters__title">${dropdownLabel}</h2>
                                <label class="lp-filter-bar__close insights-global-filters__icon-btn" for="${dropdownId}" aria-label="Close filters">
                                    ${LpIcon({ name: "x", size: 16 })}
                                </label>
                            </header>
                            <div class="lp-filter-bar__dropdown-list insights-global-filters__list">
                                ${controls}
                            </div>
                        </div>
                    </div>
                </div>
                ${actions
        ? html `<div class="control-bar__actions">${actions}</div>`
        : ""}
            </div>
        </div>
    `;
}
export function LpFilterCell({ children, search = false, narrow = false, className, attributes, }) {
    return html `
        <div
            data-lp-component="FilterCell"
            class="${cn("list-page-filter-cell", search && "list-page-filter-cell--search", narrow && "list-page-filter-cell--narrow", className, attributes?.class)}"
            ${spreadAttrs(attributes, { omit: filterCellManagedAttrs })}
        >
            ${children}
        </div>
    `;
}
export function LpSearchInput({ type = "text", placeholder, ariaLabel = placeholder, className, attributes, }) {
    return html `
        <input
            data-lp-component="SearchInput"
            class="${cn("list-page-search-input", className, attributes?.class)}"
            ${attr("type", type)}
            ${attr("placeholder", placeholder)}
            ${attr("aria-label", ariaLabel)}
            ${spreadAttrs(attributes, { omit: searchInputManagedAttrs })}
        />
    `;
}
